export const getBookingSubjectName = (booking) => {
  if (booking?.subject && typeof booking.subject === 'object') {
    return booking.subject.name || booking.subjectName || '—';
  }
  return booking?.subject || booking?.subjectName || '—';
};

export const getBookingStatusLabel = (status) => {
  const labels = {
    tutor_review: 'Pending tutor approval',
    pending: 'Pending payment',
    confirmed: 'Confirmed',
    completed: 'Completed',
    cancelled: 'Cancelled',
  };
  return labels[status] || status || 'Unknown';
};
